import React from 'react';
import './Features.css';
import featureImg from '../Images/cric2.png';

const features = [
  {
    title: "Versatile Payment Options",
    desc: "Effortlessly manage payments for services such as DTH/Cable TV, Electricity, Broadband/Landline, Postpaid Mobile, Water, Piped Gas, Education, FASTag Recharge, Credit Cards, Municipal Tax, and Insurance through a streamlined, user-friendly interface."
  },
  {
    title: "Convenient Payment Methods",
    desc: "Make payments using Credit Cards, Debit Cards, NetBanking, and UPI, all tracked conveniently within the app. Stay informed and manage your expenses efficiently with our intuitive payment gateway services."
  },
  {
    title: "Easy Issue Reporting",
    desc: "If you encounter any issues during a transaction or within the app, you can report them directly through the application for prompt resolution."
  }
];

const Features1 = () => (
  <section className="features-section" id="features">
    <div className="features-container">
      <div className="features-image">
        <img src={featureImg} alt="Features" />
      </div>
      <div className="features-info">
        <h2 className="features-title">Features</h2>
        <ul className="features-list">
          {features.map((f, idx) => (
            <li key={idx} className="feature-item">
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Features1;